function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBicheiro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bicheiro",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "162.3px",
    height: "57.1px",
    viewBox: "0 0 162.3 57.1",
    style: {
      enableBackground: "new 0 0 162.3 57.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEFFFF"
    },
    d: "M67,27c0-3.8,0-7.6,0-11.4c0-1.5,0.4-2.6,2.2-2.5c1.6,0.1,1.8,1.2,1.8,2.4c0,0.5,0,1,0,1.5 c0.1,1.5-0.2,3.1,0.3,4.4c0.6,1.4,2.4,0.4,3.6,0.8c2.3,0.8,3.8,2.2,3.9,4.6c0.2,4.5,0.2,9,0,13.4c-0.2,3.3-2.3,4.8-5.7,4.8 c-3.6,0.1-5.9-1.7-6.1-5.1C66.9,35.6,67,31.3,67,27L67,27z M71,33.4L71,33.4c0,2,0,4,0.1,6c0.1,1.2,0.9,1.7,2.1,1.7 c0.9-0.1,1.7-0.5,1.7-1.4c0.1-4,0.1-8,0-12c0-1.2-1.1-1.5-2.2-1.6c-1.3,0-1.7,0.6-1.7,1.8C71,29.7,71,31.5,71,33.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEFFFF"
    },
    d: "M105,28.8c0-3.8,0-7.6,0-11.5c0-0.8,0-1.7,0-2.5c0.1-1.2,0.8-1.8,1.9-1.8s2,0.5,2,1.7c0.1,1.8,0.1,3.7,0,5.5 c0,1.2,0.5,1.6,1.7,1.8c5.5,1,6.2,1.9,6.3,7.5c0,4.3,0,8.6,0,13c0,1.5-0.4,2.6-2.2,2.5c-1.6-0.1-1.8-1.2-1.8-2.5c0-3.8,0-7.6,0-11.5 c0-1.2,0-2.3-0.1-3.5s-1.1-1.5-2.2-1.6c-1.3,0-1.7,0.6-1.7,1.8c0,4.2,0,8.3,0,12.5c0,1.2,0,2.3-0.2,3.5c-0.1,1-1,1.2-1.9,1.2 s-1.7-0.2-1.8-1.3c-0.1-1-0.1-2-0.1-3C105,36.8,105,32.8,105,28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEFFFF"
    },
    d: "M119,33.5c0-2-0.1-4,0-6c0.3-3.6,2.3-5.4,5.8-5.4c3.6,0,5.7,1.7,6.1,5.2c0.1,0.8,0.1,1.7,0.1,2.5 c-0.1,4.1-1.4,5.6-5.5,6.3c-1.1,0.2-2.5-0.3-2.5,1.5c0,1.3-0.4,2.8,1.3,3.3c1.3,0.4,2.3-0.1,2.7-1.5c0.5-1.9,2.1-1.6,3.2-1.1 c1.3,0.6,0.9,2,0.5,3.1c-0.9,2.5-3.4,3.8-6.5,3.6c-3.1-0.3-4.9-1.9-5.2-5C118.9,37.8,119,35.6,119,33.5L119,33.5z M123,29.5 c0.2,1-0.4,2.4,1.4,2.6c1.8,0.1,2.7-0.9,2.6-3.3c0-1.5-0.4-2.7-2.1-2.6C122.6,26.2,123.1,28,123,29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEFFFF"
    },
    d: "M150,33.3c0-2-0.1-4,0-6c0.3-3.5,2.3-5.3,5.9-5.3c3.6,0,5.8,1.7,6,5.2c0.2,4.1,0.2,8.3,0,12.5 c-0.2,3.6-2.2,5.3-5.9,5.3c-3.6,0-5.6-1.7-6-5.2c0-0.3,0-0.7,0-1C150,37,150,35.2,150,33.3L150,33.3z M158,33.5c0-1.8,0-3.6,0-5.4 c0-1.1-0.5-1.9-1.7-2c-1.4-0.1-2.2,0.6-2.2,2c0,3.6,0,7.3,0,10.9c0,1.4,0.8,2.1,2.2,2c1.2-0.1,1.7-0.9,1.7-2 C158,37.2,158,35.4,158,33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEFFFF"
    },
    d: "M89.1,33.2c0-2.2-0.2-4.3,0-6.5c0.3-2.9,2.4-4.5,5.5-4.7c3.2-0.1,5.4,1.2,6.2,3.9c0.3,1.1,0.6,2.4-0.8,3 c-1.1,0.4-2.4,0.4-2.8-1c-0.4-1.3-1.1-2.1-2.5-1.8C92.8,26.4,93,28,93,29.3c0,2.8,0,5.7,0,8.5c0,1.3-0.2,2.8,1.6,3.2 c1.3,0.3,2.2-0.4,2.5-1.8c0.2-0.8,0.8-1,1.4-1.1c1.6-0.3,2.6,0.5,2.5,2.1c-0.3,2.9-2.7,4.8-6,4.8s-5.5-1.8-6-4.8c-0.1-0.3,0-0.7,0-1 C89,37.2,89,35.2,89.1,33.2C89,33.2,89,33.2,89.1,33.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEFFFF"
    },
    d: "M141,35.1c0-2.5-0.1-5,0-7.5c0.2-3.1,1.6-4.9,4.2-5.4c1-0.2,2.1-0.4,2.6,0.8c0.4,0.9,0.5,2.4-0.5,2.7 c-3.1,0.9-2.2,3.3-2.3,5.3c-0.1,3.8,0,7.7,0,11.5c0,1.5-0.4,2.7-2.2,2.6c-1.6-0.1-1.8-1.2-1.8-2.4C141,40.1,141,37.6,141,35.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEFFFF"
    },
    d: "M138,34c0,3,0,6,0,9c0,1.5-0.8,2.1-2.2,2c-1.2-0.1-1.7-0.8-1.7-2c0-6.3,0-12.7,0-19c0-1.1,0.5-2,1.7-2.1 c1.4-0.1,2.2,0.6,2.2,2C138,27.3,138,30.7,138,34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEFFFF"
    },
    d: "M86,34c0,3,0,6,0,9c0,1.1-0.5,1.9-1.7,2c-1.4,0.1-2.2-0.5-2.2-2c0-6.3,0-12.7,0-19c0-1.1,0.5-1.9,1.7-2 c1.4-0.1,2.2,0.6,2.2,2.1C86,27.4,86,30.7,86,34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEFFFF"
    },
    d: "M138,18.8c0,1.6-0.6,2.3-1.8,2.3c-1.4,0.1-2.2-0.6-2.2-2c0-1.1,0.7-1.9,1.8-2C137.2,17,137.8,17.9,138,18.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEFFFF"
    },
    d: "M86,18.7c0.1,1.5-0.5,2.3-1.6,2.4c-1.3,0.2-2.3-0.4-2.4-1.8c-0.1-1.1,0.6-2,1.6-2.2C85,16.9,85.8,17.7,86,18.7z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "bichLogo",
    style: {
      fill: "#95C741"
    },
    d: "M0,28.5C-0.1,12.9,12.9,0,28.5,0C44.2,0,57.2,13.2,57,28.9S43.7,57.2,28.3,57.1 C12.8,57-0.2,44.1,0,28.5z M6.9,29c-0.4,4.6,1.2,9,4.1,13c1.3,1.8,2.9,2.7,4.9,3c4.7,0.6,8.8-1,12.4-3.9c1.2-1,2-2.2,1.3-3.9 c-0.2-0.6-0.8-1.3-0.1-1.8c0.6-0.4,1.2,0.2,1.8,0.4c2.7,1.2,2.9,1.4,1.5,4c-1.9,3.5-4.5,6.1-8.8,6.3c-1,0.1-2-0.1-2.9,0.5 c-0.4,0.3-0.8,0.7-1,1.1c-0.2,0.8,0.4,1.1,1,1.4c3,1.5,6.2,0.8,9.3,1c6.2,0.3,10.4-3.6,14.7-7.2c1-0.9-0.1-3.3,2.3-3.5 c0.3,0,0.5-0.9,0.1-1.3c-1.6-1.5-1-1.9,0.8-2.3c1.2-0.2,1.5-1.6,1.6-2.9c0-2.2,0.2-4.3,0.1-6.5c-0.3-7.4-3.8-13-10-16.7 C37.1,8,34,6.8,30.7,9c-0.6,0.4-1.3,1.1-2-0.2c-1.7-3.2-4.5-2.1-7-1.4C12.6,10.2,6.1,19.1,6.9,29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bichLogo",
    style: {
      fill: "#92C442"
    },
    d: "M38.7,21.3c0.5,0,1,0.1,1.2,0.7c0.2,1,0.3,2-0.2,2.9c-0.5,0.7-1.2,1.4-2.1,1 C37,25.6,37,24.8,37,24.1C36.9,22.7,37.5,21.8,38.7,21.3z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBicheiro);
export default __webpack_public_path__ + "static/media/logo-bicheiro.920d789dc65225e80fae6e07a2b605e5.svg";
export { ForwardRef as ReactComponent };